document.addEventListener('DOMContentLoaded', function() {
  // Add to cart functionality
  document.querySelectorAll('.js-add-to-cart').forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      const variantId = this.dataset.variantId;
      addToCart(variantId);
    });
  });

  // Quick view functionality
  document.querySelectorAll('.js-quick-view').forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      const productUrl = this.getAttribute('data-cc-quick-buy');
      if (productUrl) {
        // Use the theme's built-in quick view functionality
        fetch(productUrl)
          .then(response => response.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const quickBuyContent = doc.querySelector('.quickbuy-content');
            
            if (quickBuyContent) {
              // Remove any existing modals first
              const existingModals = document.querySelectorAll('.theme-modal.theme-modal--fullscreen');
              existingModals.forEach(modal => modal.remove());
              
              // Create and show the modal
              const modal = document.createElement('div');
              modal.className = 'theme-modal theme-modal--fullscreen';
              modal.innerHTML = `
                <div class="inner">
                  <a href="#" data-modal-close class="modal-close">&times;</a>
                  <div class="quickbuy-content-container"></div>
                </div>
              `;
              modal.querySelector('.quickbuy-content-container').appendChild(quickBuyContent);
              document.body.appendChild(modal);
              
              // Initialize the quick buy content
              if (typeof theme.initQuickBuy === 'function') {
                theme.initQuickBuy();
              }
              
              // Show the modal
              setTimeout(() => {
                modal.classList.add('reveal');
              }, 10);
              
              // Close modal functionality
              modal.querySelector('[data-modal-close]').addEventListener('click', (e) => {
                e.preventDefault();
                modal.classList.remove('reveal');
                setTimeout(() => {
                  modal.remove();
                }, 300);
              });
            }
          })
          .catch(error => console.error('Error:', error));
      }
    });
  });

  function addToCart(variantId) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: 1
        }]
      })
    })
    .then(response => response.json())
    .then(data => {
      const product = data.items[0];
      const thumbUrl = theme.Shopify.formatImage(product.image, "300x");
      const img = new Image();
      img.src = thumbUrl;

      let variantHtml = "";
      variantHtml += `<p class="cart-product__content__price"><span class="current-price theme-money">${theme.Shopify.formatMoney(product.price, theme.money_format_with_code_preference)}</span></p>`;

      let offset = 25;
      const nav = theme.Nav();
      if (nav.bar.getPositionSetting() !== "inline") {
        offset = nav.bar.height();
      }

      let imgAlt = "";
      if (product.featured_image && product.featured_image.alt) {
        imgAlt = product.featured_image.alt;
      }
      
      // Remove any existing added-to-cart modals first
      const existingModals = document.querySelectorAll('#added-to-cart');
      existingModals.forEach(modal => modal.remove());
      
      showThemeModal(
        [
          '<div id="added-to-cart" class="theme-modal theme-modal--small" role="dialog" aria-modal="true" aria-labelledby="added-to-cart-title">',
          `<div class="inner" style="top:${offset}px">`,
          '<a href="#" data-modal-close class="modal-close">&times;</a>',
          '<h4 id="added-to-cart-title">' +
            theme.icons.tick +
            theme.strings.productAddedToCart +
            "</h4>",
          '<div class="cart-product">',
          `<div class="cart-product__image"><img src="${thumbUrl}" alt="${imgAlt}"/></div>`,
          '<div class="cart-product__content">' +
            '<p class="cart-product__content__title notranslate">',
              product.product_title,
            "</p>" + `${variantHtml ? variantHtml : ""}` + "</div>",
          "</div>",
          `<p class="links links--no-checkout">`,
          '<a href="' +
            theme.routes.cart_url +
            `" class="button">` +
            theme.strings.viewCart +
            "</a>",
          '<a href="' +
            theme.routes.checkout +
            '" class="button button--checkout" [data-cc-checkout-button]>' +
            theme.strings.popupCheckout +
            "</a> ",
          "</p>",
          "</div>",
          "</div>",
        ].join(""),
        "added-to-cart",
        null
      );
      // Redirect to the cart page
      // window.location.href = '/cart';
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }

  const saveContainerArr = document.querySelectorAll(".product-card__price-save");
  saveContainerArr.forEach(handleCurrency)

  function handleCurrency(el) {
    const parent = el.parentNode;
    const baseCurrency = el.dataset.baseCurrency;
    const basePrice = el.dataset.basePrice * 1;
    const basePriceFormatted = theme.Shopify.formatMoney(basePrice, theme.money_format_with_code_preference);
    const specialPrice = el.dataset.specialPrice * 1;
    const specialPriceConvertedFormatted = theme.Shopify.formatMoney(theme.Shopify.convertCurrency(specialPrice, baseCurrency), theme.money_format_with_code_preference);
    const converted = theme.Shopify.convertCurrency(specialPrice, baseCurrency);
    const saved = converted.toFixed(2) - basePrice;
    const savedFormatted = theme.Shopify.formatMoney(saved, theme.money_format_with_code_preference);
    const template = `
      <span class="product-card__price product-card__price--current">${basePriceFormatted}</span>
      <span class="product-card__price product-card__price--original">${specialPriceConvertedFormatted}</span>
      <span class="product-card__price-save">Save ${savedFormatted}</span>
    `;
    parent.innerHTML = template;
  }
});
